var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"title":_vm.localText}},[(_vm.direction === _vm.SORT_DIRECTIONS.ASC)?_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.SORT_ASC,"text":_vm.localText}}):_vm._e(),(_vm.direction === _vm.SORT_DIRECTIONS.DESC)?_c('app-icon',{attrs:{"name":_vm.ICON_NAMES.SORT_DESC,"text":_vm.localText}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }